import {Component, Input} from '@angular/core';

@Component({
  selector: 'weekdays-panel',
  templateUrl: 'weekdays-panel.html',
  styleUrls: ['weekdays-panel.scss'],
})
export class WeekdaysPanel {

  @Input()
  public title: string;

  @Input()
  public valueOnly: boolean = false;

  @Input() public model: Array<boolean>;
}
